
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ILink } from '../../../_shared/models/link.model';
import { ButtonComponent } from '../../../button/button.component';
import { INavigationMenuSimple } from '../../../_shared/models/navigation/menu/navigation-menu-simple.model';
import { ILogo } from '../../../_shared/models/logo.model';
import { ContainerComponent } from '../../../container/container.component';

@Component({
    selector: 'sirius-navigation-menu-simple',
    imports: [ButtonComponent, ContainerComponent],
    templateUrl: './navigation-menu-simple.component.html',
    styleUrl: './navigation-menu-simple.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-m-bold' }
})
export class NavigationMenuSimpleComponent implements OnInit {
    config?: INavigationMenuSimple;
    @Input({ required: true }) text!: string;
    @Input({ required: true }) link!: ILink;
    @Input({ required: true }) logo!: ILogo;

    ngOnInit(): void {
        if (this.config) {
            this.text = this.config.text;
            this.link = this.config.link;
            this.logo = this.config.logo;
        }
    }
}
